<template>
  <div class="report">
    <app-breadcrumb>
      <template #contentright>
        <span>&nbsp;</span>
      </template>
    </app-breadcrumb>
    <div class="card filter mb-1">
      <div class="card-body p-1">
        <div class="row">
          <div class="col-12 col-md-2">
            <b-form-group label="Kỳ thống kê"
              class="mb-0">
              <v-select v-model="thongke"
                :options="dataThongke"
                label="name"
                :reduce="(val) => val.id"
                placeholder="--Chọn--" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-2">
            <b-form-group v-if="thongke == 2"
              class="mb-0"
              label="Từ ngày">
              <flat-pickr v-model="start_date"
                :value="start_date"
                class="form-control"
                :config="config_date"
                placeholder="dd-mm-yyyy" />
            </b-form-group>
            <b-form-group v-else
              label="Năm"
              class="mb-0">
              <v-select v-model="year"
                :options="dataYear"
                label="name"
                :reduce="(val) => val.id"
                placeholder="--Chọn--" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-2">
            <b-form-group v-if="thongke == 2"
              class="mb-0"
              label="Đến ngày">
              <flat-pickr v-model="end_date"
                :value="end_date"
                class="form-control"
                :config="config_date"
                placeholder="dd-mm-yyyy" />
            </b-form-group>
            <b-form-group v-else
              label="Tháng"
              class="mb-0">
              <v-select v-model="month"
                :options="dataMonth"
                label="name"
                :reduce="(val) => val.id"
                placeholder="--Chọn--" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <b-form-group label="Phòng"
              class="mb-0">
              <v-select v-model="department_id"
                :options="department"
                label="name"
                :reduce="(val) => val.id"
                placeholder="--Chọn--" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <div style="padding-top: 2rem">
              <b-button variant="primary"
                @click="updateSearchQuery"> Thực hiện </b-button>
              <b-button variant="info"
                :disabled="disableBtn"
                @click="exportExcel"
                class="ml-1">Xuất excel </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-overlay :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm">
      <div class="card">
        <div class="card-body p-0">
          <b-table ref="refListTable"
            class="table-responsive table-nowrap"
            :items="dataItems"
            id="tableID"
            responsive
            :fields="tableColumns"
            primary-key="id"
            show-empty
            empty-text="Chưa có dư liệu" />
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import {
  BFormCheckbox,
  BFormGroup,
  BButton,
  BOverlay,
  BTable,
  BRow,
  BCol,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import useJwt from '@/auth/jwt/useJwt';
export default {
  components: {
    AppBreadcrumb,
    vSelect,
    BFormGroup,
    BFormCheckbox,
    BButton,
    BOverlay,
    BTable,
    flatPickr
  },
  data() {
    return {
      dataThongke: [
        { id: 1, name: 'Tháng' },
        { id: 2, name: 'Khoảng thời gian' },
      ],
      dataSource: [
        { id: 1, name: 'TTXVN' },
        { id: 2, name: 'CNN' },
      ],
      dataMonth: [
        { id: 1, name: 'Tháng 1' },
        { id: 2, name: 'Tháng 2' },
        { id: 3, name: 'Tháng 3' },
        { id: 4, name: 'Tháng 4' },
        { id: 5, name: 'Tháng 5' },
        { id: 6, name: 'Tháng 6' },
        { id: 7, name: 'Tháng 7' },
        { id: 8, name: 'Tháng 8' },
        { id: 9, name: 'Tháng 9' },
        { id: 10, name: 'Tháng 10' },
        { id: 11, name: 'Tháng 11' },
        { id: 12, name: 'Tháng 12' },
      ],
      dataContenType: [
        { value: "news", text: 'Tin tức', icon: "icon_news" },
        { value: "photo", text: 'Ảnh', icon: "icon_photo" },
        { value: "video", text: 'Video', icon: "icon_video" },
        { value: "audio", text: 'Audio', icon: "icon_audio" },
      ]
    };
  },
  setup() {
    const dataUser = useJwt.getUser();
    const thongke = ref(1);
    const year = ref('');
    const month = ref('')
    const content_type = ref([])
    const department_id = ref('')
    const category_id = ref('')
    const department = ref([])
    const dataItems = ref([])
    const start_date = ref('')
    const end_date = ref('')
    const all_cats = ref([])
    const loading = ref(true)
    const file_name = ref('Ban_Kỳ thống kê.xls');
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth() + 1;
    let currentDay = new Date().getDate();
    const disableBtn = ref(false)
    let currentDate = `${currentDay}-${currentMonth}-${currentYear}`;

    let dataYear = ref([{ id: currentYear, name: currentYear }]);
    for (let i = 1; i < 10; i++) {
      let text = currentYear - i;
      dataYear.value.push({ id: text, name: text });
    }

    if (year.value == '') {
      year.value = currentYear
    }
    if (month.value == '') {
      month.value = currentMonth
    }

    const tableColumns = [
      { key: 'id', sortable: false, label: 'STT' },
      { key: 'name', sortable: false, label: 'Phòng' },
      { key: 'total', label: 'Số lượng tin', },
      { key: 'tc', label: 'Tin chay', },
      { key: 'ts', label: 'Tin sống', },
      { key: 'pa', label: 'Phản ánh', },
      { key: 'pv', label: 'Phỏng vấn', },
      { key: 'ps', label: 'Phóng sự', },
      { key: 'th', label: 'Tổng hợp', },
      { key: 'tb', label: 'Bài', },
      { key: 'bl', label: 'Bình luận', },
      { key: 'tv', label: 'Tin video', },
      { key: 'ca', label: 'Chùm ảnh', },
      { key: 'use', label: 'Đã sử dụng', },
      { key: 'not_use', label: 'Chưa sử dụng', },
    ];
    const tableField = {
      'STT': 'id',
      'Phòng': 'name',
      'Số lượng': 'total',
      'Tin chay': 'tc',
      'Tin sống': 'ts',
      'Phản ánh': 'pa',
      'Phỏng vấn': 'pv',
      'Phóng sự': 'ps',
      'Tổng hợp': 'th',
      'Bài': 'tb',
      'Bình luận': 'bl',
      'Tin video': 'tv',
      'Chùm ảnh': 'ca',
      'Đã sử dụng': 'use',
      'Chưa sử dụng': 'not_use'
    }

    const fetchData = () => {
      store.dispatch('report/fetchData', {
        card_type: 'department',
        department_id: department_id.value,
        category_id: category_id.value,
        year: (start_date.value) ? '' : year.value,
        month: (start_date.value) ? '' : month.value,
        content_type: content_type.value,
        start_date: start_date.value,
        end_date: end_date.value,
        type: 'json'
      }).then(response => {
        let result = response.data;
        loading.value = false;
        if (result.code == 200) {
          dataItems.value = result.data.data
          file_name.value = result.data.file_name
          if (result.data.config.all_cats) {
            all_cats.value = result.data.config.all_cats
          }
          if (result.data.config.department) {
            department.value = result.data.config.department
          }

        }
      })
    }
    fetchData()

    const updateSearchQuery = () => {
      loading.value = true;
      if (start_date.value && start_date.value > end_date.value) {
        showToast('Đến ngày phải lớn hơn từ ngày');
        return false
      }
      fetchData();
    };
    const config_date = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });

    const exportExcel = () => {

      if (start_date.value && start_date.value >= end_date.value) {
        showToast('Đến ngày phải lớn hơn từ ngày');
        return false;
      }
      loading.value = true;
      store.dispatch('report/fetchData', {
        card_type: 'department',
        year: (start_date.value) ? '' : year.value,
        month: (start_date.value) ? '' : month.value,
        content_type: content_type.value,
        start_date: start_date.value,
        end_date: end_date.value,
        type: 'blob',
      }).then(response => {

        loading.value = false;
        disableBtn.value = true
        if (response.data) {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          let filename = dataUser.department_unit_name + '_Thống kê '
          if (start_date.value && end_date.value) {
            filename += ' từ ngày ' + start_date.value + ' đến ' + end_date.value + '.xlsx'
          } else {
            filename += ' tháng ' + month.value + ' năm ' + year.value + '.xlsx'
          }
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          disableBtn.value = false
          showToast('Tải file thành công', { variant: 'success' });
        } else {
          showToast('Lỗi tải file')
          disableBtn.value = false
        }
      })

    }


    return {
      thongke,
      dataYear,
      year,
      month,
      content_type,
      all_cats,
      department,
      department_id,
      tableColumns,
      category_id,
      dataItems,
      updateSearchQuery,
      start_date,
      end_date,
      config_date,
      tableField,
      loading,
      exportExcel,
      file_name,
      disableBtn
    }
  },

}
</script>

<style lang="scss">
.report {
  .filter {
    .row {
      margin: 0 -0.5rem;

      .col-12 {
        padding-left: 0.5rem;
        padding-right: 0.5rem;

        .content_type {
          div {
            margin-top: 4px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .custom-control,
            .custom-control-label {
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .form-group {
    .col-form-label {
      font-weight: bold
    }
  }
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>